import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from '../store'
import PatientVitalsMetadata from 'model/PatientVitalsMetadata'
import PatientVitalsMetadataRepository from 'clients/db/PatientVitalsMetadataRepository'

interface VitalsMetadataState {
  isLoading: boolean
  patientVitalsMetadata: PatientVitalsMetadata
}

const initialState: VitalsMetadataState = {
  isLoading: false,
  patientVitalsMetadata: {} as PatientVitalsMetadata,
}

function startLoading(state: VitalsMetadataState) {
  state.isLoading = true
  state.patientVitalsMetadata = {} as PatientVitalsMetadata
}

const patientVitalsMetaDataSlice = createSlice({
  name: 'patientVitalsMetaData',
  initialState,
  reducers: {
    fetchPatientVitalsMetaDataStart: startLoading,
    fetchPatientVitalsMetadataSuccess(state, { payload }: PayloadAction<PatientVitalsMetadata>) {
      state.isLoading = false
      state.patientVitalsMetadata = payload
    },
  },
})

export const {
  fetchPatientVitalsMetaDataStart,
  fetchPatientVitalsMetadataSuccess,
} = patientVitalsMetaDataSlice.actions

export const fetchPatientVitalsMetaData = (id: string): AppThunk => async (dispatch) => {
  dispatch(fetchPatientVitalsMetaDataStart())
  const patientVitalsMetadata = await PatientVitalsMetadataRepository.search(id)
  if (patientVitalsMetadata[0]) {
    dispatch(fetchPatientVitalsMetadataSuccess(patientVitalsMetadata[0]))
  }
}

export const updatePatientVitalsMetaData = (
  patientVitalsMetaData: any,
  onSuccess?: (patientData: PatientVitalsMetadata) => void,
): AppThunk => async (dispatch) => {
  const updatedPatientData = await PatientVitalsMetadataRepository.saveOrUpdate(
    patientVitalsMetaData,
  )
  dispatch(fetchPatientVitalsMetadataSuccess(updatedPatientData))
  if (onSuccess) {
    onSuccess(updatedPatientData)
  }
}

export default patientVitalsMetaDataSlice.reducer
